// Core version + modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// Import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const containers = document.querySelectorAll('.swiper.swiper-timeline');

if (containers.length > 0) {
  containers.forEach((element) => {
    initSwiper(element);
  });
}

function initSwiper(container) {
  const columnsDesktop = container.dataset.columnsDesktop ?? 3;

  const customBreakpoints = {
    0: {
      slidesPerView: 1.1,
      spaceBetween: 16,
      direction: 'horizontal',
      navigation: {
        enabled: true,
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
        navigationDisabledClass: 'swiper-navigation-disabled'
      },
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 16,
      direction: 'horizontal',
      navigation: {
        enabled: true,
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
        navigationDisabledClass: 'swiper-navigation-disabled'
      },
    },
    990: {
      slidesPerView: columnsDesktop,
      spaceBetween: 24,
      direction: 'vertical',
      navigation: {
        enabled: false,
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
        navigationDisabledClass: 'swiper-navigation-disabled'
      },
    }
  };

  // init Swiper:
  const swiper = new Swiper(container, {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    init: false,
    direction: "horizontal", // Default direction for mobile-first
    pagination: {
      el: container.querySelector(".swiper-pagination"),
      clickable: true,
      dynamicBullets: false,
      renderBullet: function (index, className) {
        return '<span class="button ' + className + '">Step ' + (index + 1) + '</span>';
      },
    },
    breakpoints: customBreakpoints,
    on: {
      resize: function () {
        this.changeDirection(window.innerWidth >= 990 ? 'vertical' : 'horizontal');
        centerPagination(this);
      },
      init: function() {
        this.changeDirection(window.innerWidth >= 990 ? 'vertical' : 'horizontal');
        centerPagination(this, false);
      },
      slideChange: function () {
        centerPagination(this);
      },
      paginationUpdate: function () {
        centerPagination(this);
      }
    }
  });

  swiper.init();
}

function centerPagination(swiper, smooth = true) {
  const paginationEl = swiper?.pagination?.el;
  if (!paginationEl) return;

  const activeBullet = paginationEl.querySelector('.swiper-pagination-bullet-active');
  if (!activeBullet) return;

  const containerWidth = paginationEl.clientWidth;
  const targetCenter = activeBullet.offsetLeft + (activeBullet.offsetWidth / 2);
  let newScrollLeft = targetCenter - (containerWidth / 2);

  const maxScrollLeft = Math.max(0, paginationEl.scrollWidth - containerWidth);
  if (newScrollLeft < 0) newScrollLeft = 0;
  if (newScrollLeft > maxScrollLeft) newScrollLeft = maxScrollLeft;

  paginationEl.scrollTo({ left: newScrollLeft, behavior: smooth ? 'smooth' : 'auto' });
}